import { render, staticRenderFns } from "./TournamentSwiper.vue?vue&type=template&id=43a3dc38&scoped=true&"
import script from "./TournamentSwiper.vue?vue&type=script&lang=js&"
export * from "./TournamentSwiper.vue?vue&type=script&lang=js&"
import style0 from "./TournamentSwiper.vue?vue&type=style&index=0&id=43a3dc38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a3dc38",
  null
  
)

export default component.exports